
import React, { useState } from 'react'
import {
  Menu,
  Bell,
  Search,
  X
} from 'lucide-react'
import UserMenu from './UserMenu'
import MobileSearchOverlay from './MobileSearchOverlay'
import AdminUserSwitcher from './AdminUserSwitcher'
import AdminRolePicker from './AdminRolePicker'
import { User } from '../types/auth'
import { useRoleOverride } from '../contexts/RoleOverrideContext'
import { Z_INDEX } from '@/lib/constants/z-index'



interface HeaderProps {
  onMobileMenuOpen: () => void
  user: User | null
  onLogout: () => void
}

export default function Header({ onMobileMenuOpen, user, onLogout }: HeaderProps) {
  const [mobileSearchOpen, setMobileSearchOpen] = useState(false)
  const { effectiveRole, setRoleOverride, canOverrideRole } = useRoleOverride()

  return (
    <>
      <header
        className="bg-brand-dark-light/95 backdrop-blur-sm border-b border-gray-700/50 px-4 py-4 relative"
        style={{ zIndex: Z_INDEX.HEADER }}
      >
        {/* Subtle gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-brand-primary/5 to-transparent opacity-50" />

        <div className="flex items-center justify-between relative z-10">
          <div className="flex items-center flex-1">
            <button
              onClick={onMobileMenuOpen}
              className="lg:hidden btn-icon text-gray-400 hover:text-white mr-4"
            >
              <Menu size={20} />
            </button>
            
            {/* Desktop Search */}
            {/* <div className="hidden md:block">
              <div className="relative group">
                <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 group-focus-within:text-brand-primary transition-colors duration-200 pointer-events-none z-10" size={20} />
                <input
                  type="text"
                  placeholder="Buscar colaboradores, documentos..."
                  className="form-input pl-10 pr-4 py-2 text-sm w-80 transition-all duration-200 hover:border-gray-600 focus:ring-brand-primary/20"
                  style={{ paddingLeft: '3rem' }}
                />
              </div>
            </div> */}

            {/* Mobile Search Button */}
            <button
              onClick={() => setMobileSearchOpen(true)}
              className="md:hidden btn-icon text-gray-400 hover:text-brand-primary ml-2"
            >
              <Search size={20} />
            </button>
          </div>

          <div className="flex items-center space-x-3 sm:space-x-4">
            {/* Notifications */}
            {/* <button className="btn-icon text-gray-400 hover:text-brand-primary relative group">
              <Bell size={20} className="transition-transform duration-200 group-hover:rotate-12" />
              <span className="absolute -top-1 -right-1 h-3 w-3 bg-brand-red rounded-full flex items-center justify-center animate-pulse">
                <span className="text-xs text-white font-bold">3</span>
              </span>
            </button> */}

            {/* Admin Role Picker */}
            {canOverrideRole && (
              <AdminRolePicker
                currentRole={effectiveRole}
                onRoleChange={setRoleOverride}
              />
            )}

            {/* Admin User Switcher */}
            <AdminUserSwitcher />

            {/* User Menu */}
            <UserMenu user={user} onLogout={onLogout} />
          </div>
        </div>

        {/* Mobile Search Overlay */}
        <MobileSearchOverlay 
          isOpen={mobileSearchOpen} 
          onClose={() => setMobileSearchOpen(false)} 
        />
      </header>
    </>
  )
}